import * as React from "react";

import { DriveRow } from "@/views/drive/components/driveRow";

type Props = React.ComponentProps<typeof DriveRow>;

export const DriveTableRow: React.FC<Props> = props => <DriveRow {...props} />;
